<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-radio-group v-model="config[field.key]" class="radio-group" @change="change" type="flex">
                <div v-for="(item,index) in field['radio-list']" :key="index" class="radio-item">
                    <el-radio :label="item.value"><img :src="item.url" alt="" :width="field.width"></el-radio>
                    <span v-if="item.text"
                          :class="index === currentRadioIndex - 1 ? 'selected' : ''">{{item.text}}</span>
                </div>
            </el-radio-group>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
    .radio-group {
        .radio-item {
            display: inline-block;
            padding-right: 8px;
            margin-bottom: 10px;

            img {
                border: 1px solid #E3E7EE;
            }

            [aria-checked=true] img {
                border: 1px solid #4A8EF7;
            }

            span {
                display: block;
                font-size: 13px;
                padding: 10px 0 10px 0;
                margin: 0 0 0 24px;
                text-align: center;
            }
            span.selected {
                color: #4A8EF7;
            }
        }

    }
</style>

<script>

  export default {
    name: 'tms-type-radio-box-img',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      source: {
        type: String,
      }
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    computed: {
      // 右侧组件数据初始化
      config() {
        if (this.source === 'tmsPageConfig') {
        return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
        return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {
        radio: 0,
        currentRadioIndex: 1,
      }
    },

    components: {},

    mounted() {
    },

    methods: {
      change(val) {
        this.currentRadioIndex = val;
      }
    }
  }

</script>
